"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.mergeCollaborativeNotePayloads = mergeCollaborativeNotePayloads;
const utils_1 = require("@standardnotes/utils");
const TypeCheck_1 = require("../../../Abstract/Payload/Interfaces/TypeCheck");
const NoteCollaboration_1 = require("../../../Syncable/Note/NoteCollaboration");
const DirtyCounter_1 = require("../../DirtyCounter/DirtyCounter");
/**
 * Resolves a conflict of two versions of a collaborative Super note by merging their Yjs states
 * (ConflictStrategy.MergeCollaborativeNote). Returns undefined when the payloads cannot be merged.
 */
function mergeCollaborativeNotePayloads(basePayload, applyPayload) {
    if (!(0, TypeCheck_1.isDecryptedPayload)(basePayload) || !(0, TypeCheck_1.isDecryptedPayload)(applyPayload)) {
        return undefined;
    }
    const baseContent = basePayload.content;
    const applyContent = applyPayload.content;
    const content = Object.assign(Object.assign({}, baseContent), {
        /** Title is not part of the Yjs state: keep the local one, unless it is empty */
        title: baseContent.title || applyContent.title, references: (0, utils_1.uniqCombineObjArrays)(baseContent.references, applyContent.references, ['uuid', 'content_type']), myRadmitClaudeCollaboration: (0, NoteCollaboration_1.mergeNoteCollaborationStates)(baseContent, applyContent)
    });
    const payload = basePayload.copyAsSyncResolved({
        updated_at: applyPayload.serverUpdatedAt,
        updated_at_timestamp: applyPayload.updated_at_timestamp,
        dirty: true,
        dirtyIndex: (0, DirtyCounter_1.getIncrementedDirtyIndex)(),
        lastSyncEnd: new Date(),
        content,
    }, applyPayload.source);
    return [payload];
}
